export default __webpack_public_path__ + "static/media/015-couple-2.be1a54f2.png";